<div class="filter-box grid align-center">
  <div class="xs-12 m-2 title">{{'product-sections-filter.by-category' | i18next}}</div>
  <div class="xs-12 m-10">
    <div class="product-sections-filter scroll-h">
      <div class="product-sections"
           (click)="handleProductSectionsSelected('Geschirr')"
           [ngClass]="{'selected': productSectionsSelected.Geschirr}"
      >
        <div class="product-sections-img">
          <img src="../../../../assets/img/product_sections/dishes.svg">
          <img class="checkmark" src="./assets/img/checkmark-circle.svg">
        </div>
        {{'product-sections-filter.dishes' | i18next}}
      </div>
      <div class="product-sections"
           (click)="handleProductSectionsSelected('Trinkglas')"
           [ngClass]="{'selected': productSectionsSelected.Trinkglas}"
      >
        <div class="product-sections-img">
          <img src="../../../../assets/img/product_sections/glas.svg">
          <img class="checkmark" src="./assets/img/checkmark-circle.svg">
        </div>
        {{'product-sections-filter.drinking-glass' | i18next}}
      </div>
      <div class="product-sections"
           (click)="handleProductSectionsSelected('Besteck')"
           [ngClass]="{'selected': productSectionsSelected.Besteck}"
      >
        <div class="product-sections-img">
          <img src="../../../../assets/img/product_sections/cutlery.svg">
          <img class="checkmark" src="./assets/img/checkmark-circle.svg">
        </div>
        {{'product-sections-filter.cutlery' | i18next}}
      </div>
      <div class="product-sections"
           (click)="handleProductSectionsSelected('Deko/Geschenke')"
           [ngClass]="{'selected': productSectionsSelected['Deko/Geschenke']}"
      >
        <div class="product-sections-img">
          <img src="../../../../assets/img/product_sections/icn-geschenke.svg">
          <img class="checkmark" src="./assets/img/checkmark-circle.svg">
        </div>
        {{'product-sections-filter.gifts' | i18next}}
      </div>
      <div class="product-sections"
           (click)="handleProductSectionsSelected('Backen/Servieren')"
           [ngClass]="{'selected': productSectionsSelected['Backen/Servieren']}"
      >
        <div class="product-sections-img">
          <img src="../../../../assets/img/product_sections/icn-backen-servieren.svg">
          <img class="checkmark" src="./assets/img/checkmark-circle.svg">
        </div>
        {{'product-sections-filter.baking' | i18next}}
      </div>
      <div class="product-sections"
           (click)="handleProductSectionsSelected( 'Kids')"
           [ngClass]="{'selected': productSectionsSelected.Kids}"
      >
        <div class="product-sections-img">
          <img src="../../../../assets/img/product_sections/icn-kids.svg">
          <img class="checkmark" src="./assets/img/checkmark-circle.svg">
        </div>
        {{'product-sections-filter.kids' | i18next}}
      </div>
      <div class="product-sections"
           (click)="handleProductSectionsSelected( 'Neuheit')"
           [ngClass]="{'selected': productSectionsSelected.Neuheit}"
      >
        <div class="product-sections-img">
          <img src="../../../../assets/img/product_sections/icn-neu.svg">
          <img class="checkmark" src="./assets/img/checkmark-circle.svg">
        </div>
        {{'product-sections-filter.news' | i18next}}
      </div>
      <div class="product-sections"
           (click)="handleProductSectionsSelected('Xmas')"
           [ngClass]="{'selected': productSectionsSelected.Xmas}"
      >
        <div class="product-sections-img">
          <img src="../../../../assets/img/product_sections/icn-xmas.svg">
          <img class="checkmark" src="./assets/img/checkmark-circle.svg">
        </div>
        {{'product-sections-filter.xmas' | i18next}}
      </div>
      <div class="product-sections"
           (click)="handleProductSectionsSelected('Ostern')"
           [ngClass]="{'selected': productSectionsSelected.Ostern}"
      >
        <div class="product-sections-img">
          <img src="../../../../assets/img/product_sections/icn-ostern.svg">
          <img class="checkmark" src="./assets/img/checkmark-circle.svg">
        </div>
        {{'product-sections-filter.easter' | i18next}}
      </div>
    </div>
  </div>
</div>
